import { ca } from '@cian/analytics';

export const trackBlackFridayAppRedirectBannerClick = () => trackBlackFridayAppRedirectBannerEvent('click_sopr');
export const trackBlackFridayAppRedirectBannerShow = () => trackBlackFridayAppRedirectBannerEvent('show_sopr');

function trackBlackFridayAppRedirectBannerEvent(action: 'show_sopr' | 'click_sopr') {
  ca('eventSite', {
    action,
    category: 'BlackFriday',
    label: 'to_object_listing',
    name: 'oldevent',
  });
}
